<template>
  <form
    id="tabulator-html-filter-form"
    @submit.prevent="onFilter"
    class="flex flex-col sm:flex-rows gap-4"
  >
    <div class="flex flex-col xl:flex-row items-start gap-4">
      <div class="flex flex-col sm:flex-row items-start w-full sm:w-auto gap-4">
        <div class="sm:flex items-center w-full sm:w-96">
          <TailSelect
            id="company-selected"
            v-model="filter.companySelected"
            placeholder="-- เลือกบริษัท --"
            :options="{
              hideSelected: true,
              hideDisabled: true,
              multiContainer: true,
              classNames: 'w-full'
            }"
            multiple
          >
            <option
              v-for="com in companyOption"
              :key="com.value"
              :value="com.value"
              >{{ com.label }}</option
            >
          </TailSelect>
        </div>
        <div class="sm:flex items-center w-full sm:w-64">
          <TailSelect
            id="status-selected"
            v-model="filter.statusSelected"
            placeholder="-- สถานะเอกสาร --"
            :options="{
              hideSelected: true,
              hideDisabled: true,
              multiContainer: true,
              classNames: 'w-full'
            }"
            multiple
          >
            <option
              v-for="status in statusOption"
              :key="status.value"
              :value="status.value"
              >{{ status.label }}</option
            >
          </TailSelect>
        </div>
      </div>

      <div class="flex flex-col sm:flex-row w-full gap-4">
        <div class="sm:flex items-center sm:mr-4">
          <select
            id="tabulator-html-filter-field"
            v-model="filter.field"
            class="form-select w-full sm:w-48 xxl:w-full sm:mt-0"
          >
            <option
              v-for="opt in filterOption"
              :key="opt.value"
              :value="opt.value"
              >{{ opt.label }}</option
            >
          </select>
        </div>
        <div class="sm:flex items-center sm:mr-4 xl:mt-0">
          <label
            class="w-12 flex-none xl:w-auto xl:flex-initial mr-2 hidden sm:block"
            >ค้นหา</label
          >
          <input
            id="tabulator-html-filter-value"
            v-model="filter.value"
            type="text"
            class="form-control sm:w-40 xxl:w-full sm:mt-0"
            :placeholder="filterPlaceholder"
          />
        </div>
        <div class="xl:mt-0 gap-2 sm:gap-0 flex flex-row">
          <button
            id="tabulator-html-filter-go"
            type="button"
            class="btn btn-primary w-full sm:w-16"
            @click="onFilter"
          >
            ค้นหา
          </button>
          <button
            id="tabulator-html-filter-reset"
            type="button"
            class="btn btn-secondary w-full sm:w-16 mt-0 sm:ml-1"
            @click="onResetFilter"
          >
            เคลียร์
          </button>
        </div>
      </div>
    </div>
  </form>
</template>

<script lang="ts">
import { defineComponent, reactive, ref, computed, watch, onMounted } from 'vue'
import { useStore } from '@/store'

export default defineComponent({
  name: 'search',
  props: {
    module: String,
    onTab: String
  },
  emit: ['onFilter', 'onResetFilter'],
  setup(props, context) {
    const currentModule = ref(null)
    if (
      props.module === 'pr' ||
      props.module === 'po' ||
      props.module === 'gr'
    ) {
      currentModule.value = 'procurement'
    } else if (
      props.module === 'pv' ||
      props.module === 'ca' ||
      props.module === 'cl'
    ) {
      currentModule.value = 'reimburement'
    } else if (props.module === 'of' || props.module === 'rf') {
      currentModule.value = 'preorder'
    } else if (props.module === 'memo') {
      currentModule.value = 'memo'
    }
    const store = useStore()
    const filterOption = computed(
      () => store.state.global.optionFilterList[currentModule.value]
    )
    const statusOption = computed(
      () => store.state.global.optionStatusList[props.module]
    )
    const companyOption = computed(
      () => store.getters['global/getCompanyOptions']
    )
    const filterPlaceholder = ref(
      store.getters['global/getPlaceholderDefaultFilterList'](
        currentModule.value
      )
    )

    // const tableTab = computed(() => store.state[props.module].tableTab)
    const search = computed(() => store.state[props.module].search)

    const filter = reactive({
      field:
        search.value.field ||
        store.getters['global/getResetFilterList'](currentModule.value), // filterPlaceholder.value,
      type: 'like',
      value: search.value.value,
      companySelected: search.value.companySelected,
      statusSelected: search.value.statusSelected
    })

    const onFilter = () => {
      store.commit(`${props.module}/setCompanyAndStatus`, {
        companySelected: filter.companySelected,
        statusSelected: filter.statusSelected,
        value: filter.value,
        field: filter.field
      })
      context.emit('onFilter', filter)
    }

    const onResetFilter = () => {
      filter.field = store.getters['global/getResetFilterList'](
        currentModule.value
      )
      filter.type = 'like'
      filter.value = null
      filter.companySelected = []
      filter.statusSelected = []

      store.commit(`${props.module}/clearTableTab`, {
        field: filter.field
      })

      context.emit('onResetFilter')
    }

    watch(
      () => filter.field,
      newVal => {
        filterPlaceholder.value = store.getters[
          'global/getPlaceholderFilterList'
        ](newVal, currentModule.value)
      }
    )

    // watch(
    //   () => props.onTab,
    //   newVal => {
    //     if (newVal !== 'monitor') {
    //       filter.companySelected = []
    //       filter.statusSelected = []
    //       store.commit(`${props.module}/clearSelectedCompanyAndStatus`)
    //     }
    //   },
    //   {
    //     immediate: true
    //   }
    // )

    onMounted(() => {
      store.dispatch('global/loadCompany')
      store.dispatch('global/loadOptionStatus', { type: props.module })
    })

    return {
      props,
      filter,
      filterOption,
      filterPlaceholder,
      onFilter,
      onResetFilter,
      companyOption,
      statusOption
    }
  }
})
</script>
